<template>
  <div>
    <div id="homepageheader" :style="{ backgroundImage: 'url(' + image + ')' }">
      <img
        src="../../assets/images/logos/2025/PGPTitle_Logo_Color_LightBG (horizontal).png"
        id="titlelogo"
      />
      <br />
      <p class="introtext">
        working <span class="highlight">together</span> to provide <br />
        you with <span>outstanding</span> service
      </p>
    </div>
    <div class="mapheader">
      <h2>Locate a PGP Title Branch near you!</h2>
    </div>

    <div class="container-fluid">
      <div class="row align-items-center justify-content-around m-4">
        <div class="col-12 col-md-4" style="text-align: left">
          <p class="committmenttext">
            We are committed to provide you with a
            <span class="highlight2">Seamless&nbsp;Closing</span>
            and exceptional service.
          </p>
        </div>
        <div class="col-12 col-md-3 offset-md-1">
          <Map @stateSelected="StateSelected" />
        </div>
        <div class="col-12 col-md-4" style="text-align: right">
          <p class="proudmembertext">
            <img
              src="../../assets/images/logos/2025/PGPTitle_Logo_Color_LightBG (horizontal).png"
              width="75"
            /><br />
            is a proud member of the<br />
            American Land Title Association.<br />
            Learn more at:<br />
          </p>

          <a href="https://www.homeclosing101.org/"
            ><img src="../../assets/images/homeclosing101_link.gif"
          /></a>
        </div>
      </div>
      <div class="row align-items-center">
        <div class="col-12 col-md-10" style="text-align: center">
          <p class="wireinstructionstext">
            Wire Instructions WILL NOT be delivered via email. Wire Instructions
            will ONLY BE delivered to you via a Secure Message Center. Should
            you have any questions regarding wire instruction please contact
            your Escrow Officer directly using a trusted phone number.
            <br />
            Please visit
            <a href="https://www.alta.org/business-tools/wirefraud.cfm"
              >ALTA - Protect Your Money</a
            >
            for additional information about securely transferring your funds.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.proudmembertext {
  color: #5b829b;
  font-size: 12px;
  font-family: Source Sans Pro, Arial, Helvetica, sans-serif;
  text-shadow: rgb(32, 42, 47) 0px 0px 0px;
  padding-left: 50px;
  text-indent: -25px;
}
.committmenttext {
  color: #5b829b;
  font-weight: 600;
  font-size: 24px;
  font-family: Source Sans Pro, Arial, Helvetica, sans-serif;
  text-shadow: rgb(32, 42, 47) 0px 0px 0px;
  padding-left: 50px;
  text-indent: -25px;
}

.wireinstructionstext {
  color: #5b829b;
  font-weight: 600;
  font-size: 16px;
  font-family: Source Sans Pro, Arial, Helvetica, sans-serif;
  text-shadow: rgb(32, 42, 47) 0px 0px 0px;
  padding-left: 50px;
  text-indent: -25px;
}

.highlight2 {
  font-size: 45px;
  font-weight: 400;
  font-family: "Aescudos", cursive !important;
  text-shadow: rgb(32, 42, 47) 0px 0px 0px;
}

.main {
  max-width: 800px;
}
img#titlelogo {
  padding-left: 50px;
  padding-top: 55px;
}
@media only screen and (max-width: 600px) {
  img#titlelogo {
    padding-top: 35px;
    width: 80%;
  }
}
</style>

<script setup>
import { computed } from "vue";
import { useRouter } from "vue-router";
import Map from "../Map";
import image1 from "../../assets/images/homepage/pgptitle-home-1.jpg";
import image2 from "../../assets/images/homepage/pgptitle-home-2.jpg";
import image3 from "../../assets/images/homepage/pgptitle-home-3.jpg";

const router = useRouter();

const StateSelected = (value) => {
  router.push({ path: "/ContactUs/" + value });
};

const image = computed(() => {
  const myArray = [image1, image2, image3];
  return myArray[Math.floor(Math.random() * myArray.length)];
});
</script>
